import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  headerRow: {
    border: '1px #D1D1D1 solid'
  }
};

const enhance = compose();

const UserTableHead = enhance(
  ({ order, orderBy, onRequestSort, classes, isFukuoka }) => {
    return (
      <TableHead>
        <TableRow className={classes.headerRow}>
          <TableCell>{isFukuoka ? '画像' : 'メニュー画像'}</TableCell>
          <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopId'}
              direction={order}
              onClick={() => {
                onRequestSort('shopId');
              }}
            >
              {isFukuoka ? '教室ID' : '店舗ID'}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopName'}
              direction={order}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              {isFukuoka ? '教室名' : '店舗名'}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
            <TableSortLabel
              active={orderBy === 'menuId'}
              direction={order}
              onClick={() => {
                onRequestSort('menuId');
              }}
            >
              {isFukuoka ? 'コースID' : 'メニューID'}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'menuName'}
              direction={order}
              onClick={() => {
                onRequestSort('menuName');
              }}
            >
              {isFukuoka ? 'コース名' : 'メニュー名'}
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'menuChildType' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'menuChildType'}
              direction={order}
              onClick={() => {
                onRequestSort('menuChildType');
              }}
            >
              {isFukuoka ? 'コース種別' : '種別'}
            </TableSortLabel>
          </TableCell>
          {!isFukuoka && (
            <TableCell
              sortDirection={orderBy === 'menuLimitTotal' ? order : false}
            >
              <TableSortLabel
                active={orderBy === 'menuLimitTotal'}
                direction={order}
                onClick={() => {
                  onRequestSort('menuLimitTotal');
                }}
              >
                利用方法
              </TableSortLabel>
            </TableCell>
          )}
          {enabledStripeBilling === true && (
            <TableCell>サブスクチケット有無</TableCell>
          )}
          <TableCell sortDirection={orderBy === 'price' ? order : false}>
            <TableSortLabel
              active={orderBy === 'price'}
              direction={order}
              onClick={() => {
                onRequestSort('price');
              }}
            >
              {isFukuoka ? '金額' : '価格'}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
            <TableSortLabel
              active={orderBy === 'taxTypeStr'}
              direction={order}
              onClick={() => {
                onRequestSort('taxTypeStr');
              }}
            >
              税区分
            </TableSortLabel>
          </TableCell>
          <TableCell>
            {isFukuoka ? (
              <>&nbsp;&nbsp;&nbsp;コース表示</>
            ) : (
              <>&nbsp;&nbsp;&nbsp;メニュー表示</>
            )}
          </TableCell>
          {!isFukuoka && <TableCell />}
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(UserTableHead);
